// extracted by mini-css-extract-plugin
export var o_carrusel1 = "carrusel1-module--o_carrusel1--a70e2";
export var o_carrusel1__h2 = "carrusel1-module--o_carrusel1__h2--aace6";
export var o_carrusel1__intro = "carrusel1-module--o_carrusel1__intro--f5041";
export var o_carrusel1__subtitle = "carrusel1-module--o_carrusel1__subtitle--d5637";
export var o_carrusel1__text = "carrusel1-module--o_carrusel1__text--a6680";